import { CustomerCardListModel } from 'app/models/customer-cards.model';
import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { CustomerBasicInfo, CustomerLoyaltyInfo } from '../../../models/customer.model';
import { CustomerCluster, CustomerClusterDataToSend } from '../../../models/loyalty-cluster.model';
import { CustomerClusterService } from '../../../services/customer/customer-cluster.service';
import { CustomerInfoService } from '../../../services/customer/customerinfo.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';


@Component({
  selector: 'app-customer-clusters',
  templateUrl: './customer-clusters.component.html',
  styleUrls: ['./customer-clusters.component.css'],
})
export class CustomerClustersComponent implements OnInit, OnChanges {
  @Input() customerId: string;
  @Input() basicInfo: CustomerBasicInfo;
  @Input() myCustomerCode;
  @Input() cards: CustomerCardListModel[];

  // Impedisce le chiamate alla loyaltyUpdate
  @Input() mdmCustomerPermission: boolean;

  //Caso Gabrielli
  @Input() mgCustomerPermission: boolean;
  @Input() kloyCustomerPermission: boolean;

  @Output() clusterChanged: EventEmitter<boolean> =   new EventEmitter();
  @Output() clusterListChanged: EventEmitter<CustomerCluster[]> =   new EventEmitter();

  @ViewChild('clusterDropdown') clusterDropdown;

  private cardNumber = '';
  private cardList: string[];

  public clusters: CustomerCluster[];
  public clustersAvailable: CustomerCluster[];

  public clusterToAdd: CustomerCluster;
  public clusterToDelete: CustomerClusterDataToSend;
  public clusterToEdit: CustomerClusterDataToSend;

  public showAddClusterModal = false;
  public showDeleteClusterModal = false;
  public showEditClusterModal = false;
  public showWarningEdit = false;
  public isClusterAdd = false

  public addClusterDateRangeError = false;

  public dateStartModel = new Date();
  public dateEndModel = new Date('12/31/2199');

  public labels: any;
  public clusterAutocomplete: any;

  public formData : FormGroup;
  public checkStartDate: any;
  public clusterIndex: any;

  public vCustomer: CustomerLoyaltyInfo;
  public today: Date = new Date();
  constructor(
    private fb: FormBuilder,
    private translateSrv: TranslateService,
    private customerSrv: CustomerInfoService,
    private clusterSrv: CustomerClusterService,
    private notifySrv: MessageService,
    public calendarTranslateService: CalendarTranslateService
  ) { }


  ngOnChanges(changes: SimpleChanges) {
    // only logged upon a change after rendering
    this._loadClusterList();
  }

  ngOnInit() {

    if(!this.kloyCustomerPermission || (this.kloyCustomerPermission && this.cards && this.cards.length> 0)){
      //non importa se tutte le carte sono in blacklist, i cluster farli vedere. L'importante è che DEVO avere almeno una carta se considero KLOY
      this.cards.forEach(res=>{
        if (!res.flagBlackList || res.flagBlackList === '0') {
          this.isClusterAdd = true;
        }
      });

      this.translateSrv.get([
        'common.add',
        'common.cancel',
        'customerCluster.validity',
        'customerCluster.headDescription',
        'customerCluster.conversionCode',
        'customerCluster.addClusterHeader',
        'customerCluster.editClusterHeader',
        'common.save',
        'common.yes',
        'customerCluster.addClusterDescription',
        'customerCluster.removeClusterHeader',
        'customerCluster.removeClusterDescription',
        'customerCluster.selectCluster',
        'customerCluster.date_start',
        'customerCluster.date_end',
        'customerCluster.addClusterDateRangeError',
        'customerCluster.addClusterInvalidInput',
        'customerCluster.ochannelDescription',
        'customerCluster.flgDeployed',
        'card.selectCardCustomer'
      ]).subscribe(t => {

        this.labels = {
          add: t['common.add'],
          cancel: t['common.cancel'],
          save: t['common.save'],
          yes: t['common.yes'],
          validity: t['customerCluster.validity'],
          headDescription: t['customerCluster.headDescription'],
          conversionCode: t['customerCluster.conversionCode'],
          addClusterHeader: t['customerCluster.addClusterHeader'],
          editClusterHeader: t['customerCluster.editClusterHeader'],
          addClusterDescription: t['customerCluster.addClusterDescription'],
          removeClusterHeader: t['customerCluster.removeClusterHeader'],
          removeClusterDescription: t['customerCluster.removeClusterDescription'],
          selectCluster: t['customerCluster.selectCluster'],
          date_start: t['customerCluster.date_start'],
          date_end: t['customerCluster.date_end'],
          addClusterDateRangeError: t['customerCluster.addClusterDateRangeError'],
          addClusterInvalidInput: t['customerCluster.addClusterInvalidInput'],
          selectCardCustomer:  t['card.selectCardCustomer'],
        };

        this._loadClusterList().then(res => this.setData());
      });

    }
  }

  _loadClusterList(): Promise<void> {
    return new Promise(resolvePromise => {
      this.clusters = [];
      this.customerSrv.getVCustomerByHost(this.customerId).subscribe(
        res => this.vCustomer = res,
        error => console.error(error),
        () => {
          this.clusterSrv.getByCustomerId(this.vCustomer.id).subscribe(cVRes => {
            this.clusters = cVRes.data;
            this.clusterListChanged.emit(this.clusters);
          });
          this.customerSrv.getCards(this.customerId).subscribe(
            cards => {
              this.cardNumber = '';
              this.cardList = [];
              if (cards.length > 0) {
                // Inviamo a VSLP la prima carta non in blacklist
                cards.forEach(cd => {
                  if (!cd.flagBlackList || cd.flagBlackList === '0') {
                    this.cardNumber = cd.cardNo;
                    this.cardList.push(cd.cardNo);
                  }
                });
              }
            },
            error => console.log(error),
            () => {
              resolvePromise();
            }
          );
        }
      );
    });
  }
  resetDateModel(){
    this.formData.get('startDate').setValue(new Date());
    this.formData.get('endDate').setValue(new Date());
  }
  public addCustomerCluster() {

    this.clusterDateRangeVerify();
    if (this.formData.valid && this.clusterToAdd && !this.addClusterDateRangeError) {
      const clusterData: CustomerClusterDataToSend = {
        customerId: this.vCustomer.id,
        clusterHeadId: this.clusterToAdd.clusterHeadId,
        cluster: this.clusterToAdd.code,
        dtStart: moment(this.formData.get('startDate').value).format('YYYY-MM-DD'),
        dtEnd: moment(this.formData.get('endDate').value).format('YYYY-MM-DD')
      };

      this.clusterSrv.addCustomerCluster(clusterData).subscribe(() => {
        this._loadClusterList()
        .then(() => {
          this.clusterChanged.emit(true);
          this.showAddClusterModal = false;
          this.translateSrv.get(['common.success', 'common.operation_success']).subscribe(res => {
            this.notifySrv.add({severity: 'success', summary: res['common.success'], detail: res['common.operation_success']});
          });
        });
      });
    } else {
      this.notifySrv.add({ severity: 'error', detail: this.labels.addClusterInvalidInput });
    }
  }

  public editCustomerCluster() {
    this.clusterDateRangeVerify();
    if (this.formData.valid && !this.addClusterDateRangeError) {
      this.showWarningEdit = true;
    } else {
      this.notifySrv.add({ severity: 'error', detail: this.labels.addClusterInvalidInput });
    }
  }

  public onClickConfirmEdit() {
    this.clusterToEdit.dtStart = moment(this.formData.get('startDate').value).format('YYYY-MM-DD');
    this.clusterToEdit.dtEnd = moment(this.formData.get('endDate').value).format('YYYY-MM-DD');
    this.clusterSrv.editCustomerCluster(this.clusterToEdit).subscribe((res) => {
      if(res){
        this.clusterChanged.emit(true);
        this._loadClusterList()
        .then(() => {
          this.saveCustomerCluster();
          //this.clusterChanged.emit(true);
          this.showEditClusterModal = false;
          this.clusterToEdit = null;
          this.showWarningEdit = false;
          this.translateSrv.get(['common.success', 'common.operation_success']).subscribe(res => {
            this.notifySrv.add({severity: 'success', summary: res['common.success'], detail: res['common.operation_success']});
          });
        });
      }
    });
  }

  public openDeleteClusterModal(customerCluster: CustomerCluster) {
    this.showDeleteClusterModal = true;
    this.clusterToDelete = {
      id: customerCluster.id,
      customerId: customerCluster.customerId,
      clusterHeadId: customerCluster.clusterHeadId,
      cluster: customerCluster.code,
      dtStart: moment(customerCluster.date_start).format('YYYY-MM-DD'),
      dtEnd: moment(customerCluster.date_end).format('YYYY-MM-DD')
    }
  }


  public openEditClusterModal(customerCluster: CustomerCluster, index: number) {
    this.showEditClusterModal = true;
    this.clusterToEdit = {
      id: customerCluster.id,
      customerId: customerCluster.customerId,
      clusterHeadId: customerCluster.clusterHeadId,
      cluster: customerCluster.code,
      dtStart: moment(customerCluster.date_start).format('YYYY-MM-DD'),
      dtEnd: moment(customerCluster.date_end).format('YYYY-MM-DD')
    };
    this.formData.get('startDate').setValue(new Date(this.clusterToEdit.dtStart));
    this.formData.get('endDate').setValue(new Date(this.clusterToEdit.dtEnd));
    this.clusterIndex = index;
  }


  public deleteCustomerCluster() {
    this.clusterSrv.deleteCustomerCluster(this.clusterToDelete).subscribe(() => {
      this.saveCustomerCluster();
      this._loadClusterList();
      this.clusterChanged.emit(true);
      this.showDeleteClusterModal = false;
      this.translateSrv.get(['common.success', 'common.operation_success']).subscribe(res => {
        this.notifySrv.add({severity: 'success', summary: res['common.success'], detail: res['common.operation_success']});
      });
    });
  }

  public filterClusterSingle(event) {
    if(event) {
      this.clusterSrv.getClusterHeadListSoloSchedaCliente(event.query, this.vCustomer.id.toString(), true).subscribe(res => {
        this.clustersAvailable = [];
        if(res && res.data) {
          this.clustersAvailable = res.data;
        }
      })
    }
  }

 /*  public clusterSelected(customerCluster: any, endDateField: any) {
    this.clusterToAdd = customerCluster;
    let endDate = new Date(customerCluster.date_end);
    if (endDate) {
      this.dateEndModel = endDate;
      this.formData.get('endDate').setValue(new Date(endDate));
      endDateField.calendar.currentYear = this.formData.get('endDate').value.getFullYear();
      endDateField.calendar.currentMonth = this.formData.get('endDate').value.getMonth();
    }
  } */
 //KS-7794 modifica nuova data minima
 public clusterSelected(customerCluster: any, endDateField: any) {
  this.clusterToAdd = customerCluster;

  let today = new Date();
  today.setHours(0, 0, 0, 0);

  let clusterStart = new Date(customerCluster.date_start);
  clusterStart.setHours(0, 0, 0, 0);

  if (clusterStart > today) {
    this.formData.get('startDate').setValue(clusterStart);
  }

  let endDate = new Date(customerCluster.date_end);
  if (endDate) {
    this.dateEndModel = endDate;
    this.formData.get('endDate').setValue(new Date(endDate));
    endDateField.calendar.currentYear = this.formData.get('endDate').value.getFullYear();
    endDateField.calendar.currentMonth = this.formData.get('endDate').value.getMonth();
  }
}

  public openAddClusterModal() {
    if(this.mgCustomerPermission){
        //qui ci entro se non la scehda cliente non refresha i dati di una possibile blacklist dell'unica carta disponibile
        this.customerSrv.getCards(this.customerId).subscribe(
          cards => {
            this.isClusterAdd = false;
            this.cards = cards;
            cards.forEach(res=>{
              if (!res.flagBlackList || res.flagBlackList === '0') {
                this.isClusterAdd = true;
              }
            });
            if((this.mgCustomerPermission && this.isClusterAdd) ){
              this.clusterAutocomplete = '';
              this.showAddClusterModal = true;
              this.resetDateModel();
            }else{
              return;
            }
          }
        );
    }else{
      this.clusterAutocomplete = '';
      this.showAddClusterModal = true;
      this.resetDateModel();
    }
  }

  saveCustomerCluster() {
    if (this.clusters && this.clusters.length && this.clusters.length > 0 && !this.mdmCustomerPermission) {
      this.clusterSrv.saveCustomerClusterLoyalty(this.vCustomer.id).subscribe();
    }
  }

  setData(data?: any) {
    if (data) {
      this.formData = this.fb.group({
        startDate: [new Date(data.start_date).setHours(0, 0, 0, 0), Validators.required],
        endDate: [new Date(data.end_date).setHours(0, 0, 0, 0), Validators.required]
      });
    } else {
      this.formData = this.fb.group({
        startDate: ['', Validators.required],
        endDate: ['', Validators.required]
      });
    }
  }

  setDefaultDateStart() {
    const startDate = this.formData.get('startDate').value;
    if (startDate) {
        startDate.setHours(0, 0, 0, 0)
        return startDate;
    } else {
      return null;
    }
  }

  setDefaultDateEnd(endDateCluster: any) {
    const endDate = this.formData.get('endDate').value;
    if (endDate) {
        endDate.setHours(0, 0, 0, 0)
        return endDate;
    } else {
        if (endDateCluster && this.formData.get('startDate').value) {
        this.formData.get('endDate').setValue(this.formData.get('startDate').value);
        endDateCluster.calendar.currentYear = this.formData.get('startDate').value.getFullYear();
        endDateCluster.calendar.currentMonth = this.formData.get('startDate').value.getMonth();
      }
      return this.formData.get('startDate').value;
    };
  }

  clusterDateRangeVerify(){
    this.addClusterDateRangeError = false;
    this.checkStartDate = moment(this.formData.get('startDate').value).format('YYYY-MM-DD')
    if(this.clusterIndex) {
      if(this.clusters[this.clusterIndex] && this.clusters[this.clusterIndex].date_start && this.checkStartDate < this.clusters[this.clusterIndex].date_start )
        this.addClusterDateRangeError = true;
    }
    let startDate = new Date(this.formData.get('startDate').value)
    let endDate = new Date(this.formData.get('endDate').value)
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if(endDate < startDate) {
      this.addClusterDateRangeError = true;
    }
    else this.addClusterDateRangeError = false;
  }

  closeAddCluster() {
    this.showAddClusterModal = false;
    this.clusterDropdown.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-clusters/customer-clusters.component.ts